import { h } from 'preact';

import { useDeviceTypes } from '@travel/traveler-core/hooks';
import { URLSearchQuery } from '@travel/traveler-core/types/jrdpCommon';

import Rating from 'components/Rating';

import paths from 'constants/paths';

type Props = {
  id: string;
  providerName: string;
  reviewScore: number;
  totalReviews: number;
  classTitle: string;
  query?: URLSearchQuery;
};
const Header = (props: Props) => {
  const { id, providerName, reviewScore, totalReviews, classTitle, query } = props;
  const hotelTopLink = paths.hotelTop.pathResolver(id, query);
  const { isPC } = useDeviceTypes();

  return (
    <header>
      <h2>
        <a href={hotelTopLink} className={classTitle}>
          {providerName}
        </a>
      </h2>
      {totalReviews > 0 && (
        <Rating
          providerId={id}
          rating={reviewScore}
          numReviews={totalReviews}
          type={isPC ? 'withTitle' : 'default'}
          query={query}
        />
      )}
    </header>
  );
};

export default Header;
